import React from 'react';

const About = () => {
  return (
    <div>
      {/* About Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">About Cleophas Network</h1>
          <p className="text-xl max-w-2xl mx-auto">Building meaningful professional connections that transform careers and create opportunities</p>
        </div>
      </section>

      {/* About Content */}
      <section className="about-content">
        <div className="container">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold mb-6">Our Story</h2>
            <p className="text-lg mb-6">Cleophas Network was founded with a simple mission: to help people build meaningful professional connections that transform careers and create opportunities.</p>
            
            <p className="text-lg mb-6">We believe that everyone deserves the chance to build a successful online business, regardless of their background or experience level. That's why we've partnered with VumaQash to bring you multiple income streams with just one activation.</p>
            
            <h2 className="text-3xl font-bold mb-6 mt-12">Our Values</h2>
            
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                  <i className="fas fa-hand-holding-heart text-blue-600 text-xl"></i>
                </div>
                <h3 className="text-xl font-semibold mb-2">Integrity</h3>
                <p>We believe in transparency and honesty in all our dealings with clients and partners.</p>
              </div>
              
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                  <i className="fas fa-users text-blue-600 text-xl"></i>
                </div>
                <h3 className="text-xl font-semibold mb-2">Community</h3>
                <p>We're building a supportive community where members can learn and grow together.</p>
              </div>
              
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                  <i className="fas fa-rocket text-blue-600 text-xl"></i>
                </div>
                <h3 className="text-xl font-semibold mb-2">Innovation</h3>
                <p>We're constantly exploring new ways to help our members succeed in the digital economy.</p>
              </div>
              
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                  <i className="fas fa-graduation-cap text-blue-600 text-xl"></i>
                </div>
                <h3 className="text-xl font-semibold mb-2">Education</h3>
                <p>We provide comprehensive training and support to ensure our members' success.</p>
              </div>
            </div>
            
            <h2 className="text-3xl font-bold mb-6">Our Team</h2>
            
            <div className="team-grid">
              <div className="team-card">
                <div className="team-image">
                  <i className="fas fa-user"></i>
                </div>
                <h3 className="text-xl font-semibold mb-2">Cleophas</h3>
                <p className="text-blue-600 mb-2">Founder & CEO</p>
                <p className="text-sm">With years of experience in networking and digital marketing, Cleophas leads our team with vision and expertise.</p>
              </div>
              
              <div className="team-card">
                <div className="team-image">
                  <i className="fas fa-user"></i>
                </div>
                <h3 className="text-xl font-semibold mb-2">Sarah</h3>
                <p className="text-blue-600 mb-2">Community Manager</p>
                <p className="text-sm">Sarah ensures our community members get the support they need to succeed with VumaQash.</p>
              </div>
              
              <div className="team-card">
                <div className="team-image">
                  <i className="fas fa-user"></i>
                </div>
                <h3 className="text-xl font-semibold mb-2">Michael</h3>
                <p className="text-blue-600 mb-2">Training Specialist</p>
                <p className="text-sm">Michael develops comprehensive training materials to help our members maximize their earnings.</p>
              </div>
            </div>

            {/* VumaQash Section */}
            <div className="mt-16 bg-gradient-to-r from-blue-50 to-purple-50 p-8 rounded-xl border border-blue-100">
              <h2 className="text-2xl font-bold mb-4 text-blue-800">Why VumaQash?</h2>
              <p className="mb-4">VumaQash is our premier platform that offers 10 different income streams with just one activation. It's designed for:</p>
              
              <div className="grid md:grid-cols-2 gap-4 mb-6">
                <div className="flex items-start">
                  <div className="bg-blue-100 p-2 rounded-full mr-3">
                    <i className="fas fa-check-circle text-blue-600"></i>
                  </div>
                  <p>Complete beginners with no prior experience</p>
                </div>
                <div className="flex items-start">
                  <div className="bg-blue-100 p-2 rounded-full mr-3">
                    <i className="fas fa-check-circle text-blue-600"></i>
                  </div>
                  <p>People who want to work from anywhere</p>
                </div>
                <div className="flex items-start">
                  <div className="bg-blue-100 p-2 rounded-full mr-3">
                    <i className="fas fa-check-circle text-blue-600"></i>
                  </div>
                  <p>Those seeking multiple income streams</p>
                </div>
                <div className="flex items-start">
                  <div className="bg-blue-100 p-2 rounded-full mr-3">
                    <i className="fas fa-check-circle text-blue-600"></i>
                  </div>
                  <p>Individuals who prefer not to show their face online</p>
                </div>
              </div>

              <a href="https://wa.me/254115647545?text=Hey%20Cleophas,%20I%20want%20to%20learn%20more%20about%20VumaQash" 
                 className="inline-flex items-center bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg transition-colors">
                <i className="fab fa-whatsapp mr-2 text-xl"></i> Learn More on WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;